import { ArrowLeft, ShieldAlert } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

interface ErrorStatePageProps {
    code: string;
    title: string;
    description: string;
}

export default function ErrorStatePage({ code, title, description }: ErrorStatePageProps) {
    return (
        <main className="auth-shell">
            <div className="pointer-events-none absolute h-80 w-80 rounded-full bg-blue-600/10 blur-[120px]" />
            <motion.section
                initial={{ opacity: 0, y: 18, scale: 0.97 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                className="auth-card text-center"
            >
                <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-blue-500/20 bg-blue-500/10 text-blue-400 shadow-lg shadow-blue-500/10">
                    <ShieldAlert size={30} />
                </div>
                <p className="text-7xl font-black tracking-tighter text-white/10">{code}</p>
                <h1 className="app-page-title -mt-4 text-2xl font-black uppercase italic">{title}</h1>
                <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-slate-500">{description}</p>
                <Link to="/" className="ui-button-primary mt-8">
                    <ArrowLeft size={16} /> Voltar ao início
                </Link>
            </motion.section>
        </main>
    );
}
